@if (warnings.length) {
  <section class="feed-binding-warning" role="status" aria-live="polite">
    <strong>Product feed warnings</strong>
    @for (warning of warnings; track trackWarning($index, warning)) {
      <div class="feed-binding-warning__item">
        <span class="feed-binding-warning__code">{{ warning.code }}</span>
        <span>{{ warning.message }}</span>
        <span class="feed-binding-warning__action">{{ warning.action }}</span>
      </div>
    }
  </section>
}
